// LC-IMPACT engine result table — pending vendor of per-category XLSXs.
//
// Until the LC-IMPACT CFs are loaded, the persisted payload is either
// empty/null (skipped engine) or a stub. This component shows a
// holding message when the engine row exists but the payload has no
// recognisable shape.

import React from "react";

interface LcimpactEngineTableProps {
  payload: Record<string, any>;
}

export function LcimpactEngineTable({ payload }: LcimpactEngineTableProps) {
  const hasContent =
    payload &&
    Object.keys(payload).some(
      (k) =>
        typeof payload[k] === "number" ||
        (Array.isArray(payload[k]) && payload[k].length > 0),
    );

  if (!hasContent) {
    return (
      <p className="text-sm text-text-muted">
        LC-IMPACT integration pending — per-category CF XLSXs are not yet vendored
        (only the main report PDF is available today).
      </p>
    );
  }

  return (
    <div className="space-y-3">
      <p className="text-sm text-text-muted">
        LC-IMPACT engine produced output but the schema is provisional. Raw payload below.
      </p>
      <pre className="text-xs text-text-secondary bg-surface-800 rounded p-3 overflow-x-auto">
        {JSON.stringify(payload, null, 2)}
      </pre>
    </div>
  );
}
